/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import HorizontalTeamCard from "parts/Cards/TeamCards/HorizontalTeamCard";

// Images
import team1 from "assets/images/39.jpeg";
import team2 from "assets/images/40.jpeg";
import team3 from "assets/images/41.webp";
import team4 from "assets/images/42.png";
import team5 from "assets/images/43.webp";
import team6 from "assets/images/44.png";
import team7 from "assets/images/45.webp";

function Team() {
  return (
    <MKBox
      component="section"
      variant="gradient"
      bgColor="info"
      position="relative"
      py={6}
      px={{ xs: 2, lg: 0 }}
      mx={-2}
    >
      <Container>
        <Grid container>
          <Grid item xs={12} md={8} sx={{ mb: 6 }}>
            <MKTypography variant="h3" color="white">
            What We Do:
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.8}>
  At HP Tech Solutions, we are dedicated to providing cutting-edge AI and machine learning solutions, customized to address your specific challenges and goals. Our expertise empowers businesses to harness the power of data-driven insights, automation, and intelligent decision-making.
</MKTypography>

          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team1}
                name="Expertise You Can Trust"
                position={{ color: "info", label: "User Friendly" }}
                description="Our team of experienced data scientists and engineers brings years of expertise to every project."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team2}
                name="Customized Solutions"
                position={{ color: "info", label: "All Solutions" }}
                description="We take a personalized approach to address your specific challenges and goals."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team3}
                name="Cutting-Edge Technology"
                position={{ color: "info", label: "specific business goals" }}
                description="Stay ahead with the latest advancements in AI and ML."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team4}
                name="Proven Track Record"
                position={{ color: "info", label: "maximize ROI" }}
                description="Trusted by businesses across industries for delivering measurable results."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team5}
                name="End-to-End Support"
                position={{ color: "info", label: "End-to-End" }}
                description="From consultation to deployment and beyond, we’re with you every step of the way."
              />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Team;
